import React from 'react';
import { useProjectPoursQuery } from 'providers/api/usePours';
import { MINUTE_IN_MILLISECONDS } from 'config';
import { buildStopePourData, StopePourData } from '../MineModel/Meshes/stopePourTimeline';

const POUR_FETCH_PAGE_SIZE = 100000;
const EMPTY: StopePourData = {};

// Fetches all of the project's pours for the active scenario and reduces them to per-stope fill timelines.
// Gated by `enabled` so we only pull pour data while the stope shapes (and their timeline) are on screen.
const useStopePourTimelines = (
  projectId: string | undefined,
  scenarioId: string | undefined,
  enabled: boolean,
): StopePourData => {
  const { data } = useProjectPoursQuery(
    {
      projectId: projectId ?? '',
      page: 1,
      pageSize: POUR_FETCH_PAGE_SIZE,
      scenarioId,
    },
    { enabled: enabled && !!projectId, staleTime: 5 * MINUTE_IN_MILLISECONDS },
  );

  return React.useMemo(() => (data?.items ? buildStopePourData(data.items) : EMPTY), [data]);
};

export default useStopePourTimelines;
